/*
 * GSTR9CNew Common Constants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'gstr9cnew/Common' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'gstr9cnew/Common/YOUR_ACTION_CONSTANT';
 */

// Common loader actions
export const LOADER_STATUS = 'gstr9cnew/Common/LOADER_STATUS';

// Common profile and authentication
export const PROFILE_INFO = 'gstr9cnew/Common/PROFILE_INFO';

// Common notification actions
export const ON_NOTIFY = 'gstr9cnew/Common/ON_NOTIFY';
export const RESPONSE_MESSAGE = 'gstr9cnew/Common/RESPONSE_MESSAGE';

// Common table data actions
export const SET_TABLE_DATA = 'gstr9cnew/Common/SET_TABLE_DATA';
export const TOTAL_RECORD = 'gstr9cnew/Common/TOTAL_RECORD';

// Common file operations
export const FILE_UPLOAD_STATUS = 'gstr9cnew/Common/FILE_UPLOAD_STATUS';
export const FILE_VALIDATION_ERROR = 'gstr9cnew/Common/FILE_VALIDATION_ERROR';

// Common API status
export const API_SUCCESS = 'gstr9cnew/Common/API_SUCCESS';
export const API_ERROR = 'gstr9cnew/Common/API_ERROR';

export const SET_ENTITY_LIST = 'gstr9cnew/Common/SET_ENTITY_LIST';
export const SET_SELECTED_ENTITY = 'gstr9cnew/Common/SET_SELECTED_ENTITY';
export const SET_SELECTED_GSTIN = 'gstr9cnew/Common/SET_SELECTED_GSTIN';
export const SET_SELECTED_RETURN_PERIOD = 'gstr9cnew/Common/SET_SELECTED_RETURN_PERIOD';

// GSTR9C specific constants
export const SET_GSTR9C_DATA = 'gstr9cnew/Common/SET_GSTR9C_DATA';
export const SET_GSTR9C_HISTORY = 'gstr9cnew/Common/SET_GSTR9C_HISTORY';
export const SET_CLEAR_DATA = 'gstr9cnew/Common/SET_CLEAR_DATA';
